import axios from '@/axios/api.request'

export const total = (params) => axios.request({
    url: '/proffter/total',
    data: params,
    method: 'post'
  })
